module.exports = __webpack_public_path__ + "img/407.bedfaa6e.png";